// Freelancer (Party B) persona API — work marketplace.
import axiosInstance from "../api/axios";

const BASE = "/freelancers";

export const signupFreelancer = (data) => axiosInstance.post(`${BASE}/signup`, data);
export const getFreelancerProfile = () => axiosInstance.get(`${BASE}/profile`);
export const updateFreelancerProfile = (data) => axiosInstance.put(`${BASE}/profile`, data);
